import React from 'react';

interface Props {
    items: {
        key: string;
        label?: string;
    }[];
    active?: string;

    onChange?: (e: string) => void;
}
const Steps = ({ items, active, onChange }: Props) => {

    return (
        <React.Fragment>
            <div id="Steps" className="flex- justify-center w-full mx-auto">
                <ul className="steps_progress">
                    {items.map(item => (
                        <li
                            key={item.key}
                            className={`${active === item.key ? 'active' : ''} ${onChange ? 'cursor-pointer' : ''}`}
                            onClick={() => onChange && onChange(item.key)}
                        >
                            {item.label || item.key}
                        </li>
                    ))}
                    <div className="clear-both" />
                </ul>
                <div className="clear-both" />
            </div>
            <div className="clear-both" />
        </React.Fragment>
    );
}

export default Steps;